<template>
    <div>
        <v-dialog v-model="dialog" max-width="700px">
            <LabeledCard :label="$t('Фильтрация')">
                <v-container fluid>
                    <v-row dense align="center">
                        <v-col cols="12" sm="4">
                            <span class="label font-weight-bold">{{ $t('КСК') }}</span>
                        </v-col>
                        <v-col cols="12" sm="8">
                            <SelectKSKDialog v-model="filters.ksk" ref="selectKSKDialog">
                                <!-- :placeholder="$t('КСК дома')" -->
                                <v-text-field
                                    class="pointer"
                                    dense
                                    outlined
                                    readonly
                                    hide-details
                                    v-model="filters.ksk.isas_ksk_name"
                                    clearable
                                    @click:clear="clearKSKSelection"
                                ></v-text-field>
                            </SelectKSKDialog>
                        </v-col>
                    </v-row>
                    <v-row dense align="center">
                        <v-col cols="12" sm="4">
                            <span class="label font-weight-bold">{{ $t('Дом') }}</span>
                        </v-col>
                        <v-col cols="12" sm="8">
                            <AddressSelector v-model="filters.house" ref="addressSelector">
                                <!-- :placeholder="$t('Адрес дома')" -->
                                <v-text-field
                                    class="pointer"
                                    dense
                                    outlined
                                    readonly
                                    hide-details
                                    clearable
                                    @click:clear="clearHouseSelection"
                                    v-model="filters.house.address_full_name"
                                ></v-text-field>
                            </AddressSelector>
                        </v-col>
                    </v-row>

                    <v-row dense align="center">
                        <v-col cols="12" sm="4">
                            <span class="label font-weight-bold">{{ $t('Дата начала') }}</span>
                        </v-col>
                        <v-col cols="12" sm="8" class="d-flex align-center">
                            <DatePicker
                                outlined
                                dense
                                hide-details
                                class="pointer"
                                label="От"
                                v-model="filters.dateBegin[0]"
                                :max="filters.dateBegin[1] || filters.dateEnd[0] || filters.dateEnd[1]"
                            />
                            <span class="mx-2">-</span>
                            <DatePicker
                                outlined
                                dense
                                hide-details
                                class="pointer"
                                label="До"
                                v-model="filters.dateBegin[1]"
                                :min="filters.dateBegin[0]"
                                :max="filters.dateEnd[0] || filters.dateEnd[1]"
                            />
                        </v-col>
                    </v-row>

                    <v-row dense align="center">
                        <v-col cols="12" sm="4">
                            <span class="label font-weight-bold">{{ $t('Дата окончания') }}</span>
                        </v-col>
                        <v-col cols="12" sm="8" class="d-flex align-center">
                            <DatePicker
                                outlined
                                dense
                                hide-details
                                class="pointer"
                                label="От"
                                v-model="filters.dateEnd[0]"
                                :max="filters.dateEnd[1]"
                                :min="filters.dateBegin[1] || filters.dateBegin[0]"
                            />
                            <span class="mx-2">-</span>
                            <DatePicker
                                outlined
                                dense
                                hide-details
                                class="pointer"
                                label="До"
                                v-model="filters.dateEnd[1]"
                                :min="filters.dateEnd[0] || filters.dateBegin[1] || filters.dateBegin[0]"
                                :max="null"
                            />
                        </v-col>
                    </v-row>

                    <v-row dense class="mt-5">
                        <v-col cols="12" sm="6"> </v-col>
                        <v-col cols="12" sm="3">
                            <v-btn @click="cancelFilterChanges" outlined color="primary" class="rounded-btn w100">{{ $t('Отменить') }}</v-btn>
                        </v-col>
                        <v-col cols="12" sm="3" class="d-flex justify-end">
                            <v-btn @click="filterItems" color="primary" depressed :disabled="!filtersChanged" class="rounded-btn w100">{{
                                $t('Применить')
                            }}</v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </LabeledCard>
        </v-dialog>
        <v-btn :title="$t('Фильтр')" icon :color="$vuetify.theme.themes.dark.primary" @click="dialog = true" class="mr-1">
            <v-icon>mdi-filter</v-icon>
        </v-btn>
        <v-btn :title="$t('Очистить фильтр')" icon :color="$vuetify.theme.themes.dark.primary" :disabled="!filtersApplied" @click="clearFilter">
            <v-icon :color="'red'">mdi-filter-remove</v-icon>
        </v-btn>
    </div>
</template>

<script>
import LabeledCard from '@/components/ui/LabeledCard';
import DatePicker from '@/components/ui/DatePicker.vue';
import SelectKSKDialog from './SelectKSKDialog.vue';
import AddressSelector from './AddressSelector.vue';

import { deepCopy } from '@/utils/index';
import { isEqual } from 'lodash';

export default {
    components: {
        LabeledCard,
        DatePicker,
        SelectKSKDialog,
        AddressSelector
    },
    data: () => ({
        dialog: false,
        email: null,
        name: null,
        filtersChanged: false,
        filtersApplied: false,
        resetFilter: false,
        filters: {
            ksk: {},
            house: {},
            dateBegin: [null, null],
            dateEnd: [null, null]
        },
        tempFilters: {
            ksk: {},
            house: {},
            dateBegin: [null, null],
            dateEnd: [null, null]
        }
    }),
    watch: {
        filters: {
            deep: true,
            handler(newFilters) {
                if (isEqual(newFilters, this.tempFilters)) this.filtersChanged = false;
                else this.filtersChanged = true;
            }
        }
    },
    methods: {
        clearKSKSelection() {
            this.$refs.selectKSKDialog.clearSelection();
        },
        clearHouseSelection() {
            this.filters.house = {};
            this.$refs.addressSelector.clearLocalitySelection();
        },
        clearFilter() {
            this.filters = this.tempFilters = {
                ksk: {},
                house: {},
                dateBegin: [null, null],
                dateEnd: [null, null]
            };
            this.filtersApplied = false;
            this.filtersChanged = false;

            this.$emit('filter', []);
        },

        cancelFilterChanges() {
            this.filters = deepCopy(this.tempFilters);

            this.dialog = false;
        },

        filterItems() {
            this.tempFilters = deepCopy(this.filters);

            const obj = {
                ahs_ksk_rid: this.filters.ksk?.isas_ksk_rid,
                address_rid: this.filters.house?.record_id,
                date_begin: this.filters.dateBegin,
                date_end: this.filters.dateEnd
            };
            const filters = [];

            if (obj.ahs_ksk_rid) {
                filters.push({ field: 'ahs_ksk_rid', value: obj.ahs_ksk_rid });
            }
            if (obj.date_begin[0] || obj.date_begin[1]) {
                filters.push({ field: 'date_begin', value: obj.date_begin[0], value2: obj.date_begin[1] });
            }
            if (obj.date_end[0] || obj.date_end[1]) {
                filters.push({ field: 'date_end', value: obj.date_end[0], value2: obj.date_end[1] });
            }

            this.$emit('filter', filters);
            if (filters.length) this.filtersApplied = true;
            else this.filtersApplied = false;

            this.dialog = false;
        }
    },
    computed: {}
};
</script>
